import { createMuiTheme } from 'material-ui/styles';

const AppPalette = createMuiTheme({
    palette: {
        primary: {
            main: 'var(--secondary-button-color)',
            contrastText: 'var(--secondary-button--text-color)',
        },
        secondary: {
            main: 'var(--primary-button-color)',
            contrastText: 'var(--primary-button--text-color)',
        },
        error: {
            light: 'red',
            main: 'red',
            dark: 'dark red',
            contrastText: 'white',
        },
        background: {
            main: 'red',
            warning: '#FFA500',
            info: '#87CEFA',
            error: '#D2232A',
            success: '#47A801',
            popover: '#4993DC',
            menuActive: '#9DBCDB',
            menu: '#226FBD',
            tabHeaderSelected: '#3155A1',
            tabHeaderUnselected: '#A2BCD8',
            buttonActive: '#0055a6',
            buttonInactive: '#ffffff',
            filtersButton: '#2A6EBF'
        },
        text: {
            primary: '#333333',
            secondary: '#828282',
            inactiveBreadCrumb: '#808080',
            inputLabel: '#3155A1',
            link: '#7f93ff',
            hotelTitle: '#044899',
        },
        grey: {
            100: '#F5F5F5'
        },
        icon: {
            main: 'var(--primary-text-color)',
        },
        proforma: {
            background: '#0061a5'
        },
        bono: {
            titleColor: '#0054a6',
            subTitleColor: '#0054a6'
        },
        recoverPassword: {
            color: 'white'
        }
    }

});

export default AppPalette;



// WEBPACK FOOTER //
// ./src/components/AppPalette/AppPalette.default.js